export enum EnumModoSelecao {
  Padrao = 0,
  Marcacao = 1,
  MarcaTexto = 2,
  Borracha = 3,
}
